import React from "react";
import ManageJobVacancies from "../components/addvacancy";
import Footer from "../components/Navbars/footer";

function ManageVacancy() {
  return (
    <div className="flex min-h-screen flex-col">
      <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 flex-1">
        <main>
          <ManageJobVacancies />
        </main>
      </div>
    </div>
  );
}

export default ManageVacancy;
